var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46971 20.3408C-1.79873 12.8598 3.30649 5.661 10.8888 2.29272C18.471 -1.07557 25.6591 0.662168 28.9276 8.14313C32.196 15.6241 35.7288 25.9175 28.1466 29.2858C20.5643 32.6541 4.73814 27.8217 1.46971 20.3408Z",
    fill: "#EEF0FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7398,
    cy: 7.56565,
    r: 5.56565,
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09857 24.2641C4.03357 23.8097 3.99994 23.3451 3.99994 22.8727C3.99994 17.4935 8.36063 13.1328 13.7398 13.1328C16.1904 13.1328 18.4295 14.0378 20.1413 15.5318",
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6446 28.2965H17.0181C15.2423 28.2965 14.1681 26.3337 15.1254 24.8379L21.6423 14.6553C22.5414 13.2504 24.6038 13.2802 25.462 14.7104L31.5716 24.8931C32.4703 26.3909 31.3914 28.2965 29.6446 28.2965Z",
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5967 18.6016L23.5967 21.2727",
    stroke: "#1E3269",
    strokeWidth: 1.6499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5967 24.2812V24.4148",
    stroke: "#1E3269",
    strokeWidth: 1.6499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b69d99afa59aa75beb822d57190e8d1b.svg";
export { ForwardRef as ReactComponent };